import styled from 'styled-components'

export const StyledTitle = styled.span`
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.8rem;
  font-weight: 700;
  line-height: 1.3;
`
